import request from '../utils/request'

// ==================== 合同审批 ====================

/**
 * 获取合同审批列表
 */
export function getContractApprovalList(params) {
  return request({
    url: '/accountant/approval/contract/list',
    method: 'get',
    params
  })
}

/**
 * 获取合同待审批数量
 */
export function getContractPendingCount() {
  return request({
    url: '/accountant/approval/contract/pending-count',
    method: 'get'
  })
}

/**
 * 更新合同审批状态（通过/拒绝）
 */
export function updateContractApprovalStatus(data) {
  return request({
    url: '/accountant/approval/contract/update-status',
    method: 'post',
    data
  })
}

/**
 * 获取合同审批记录详情
 */
export function getContractApprovalRecords(params) {
  return request({
    url: '/accountant/approval/contract/records',
    method: 'get',
    params
  })
}

// ==================== 报销审批 ====================

/**
 * 获取报销审批列表
 */
export function getExpenseApprovalList(params) {
  return request({
    url: '/accountant/approval/expense/list',
    method: 'get',
    params
  })
}

/**
 * 获取报销待审批数量
 */
export function getExpensePendingCount() {
  return request({
    url: '/accountant/approval/expense/pending-count',
    method: 'get'
  })
}

/**
 * 更新报销审批状态（通过/拒绝）
 */
export function updateExpenseApprovalStatus(data) {
  return request({
    url: '/accountant/approval/expense/update-status',
    method: 'post',
    data
  })
}

/**
 * 获取报销审批记录详情
 */
export function getExpenseApprovalRecords(params) {
  return request({
    url: '/accountant/approval/expense/records',
    method: 'get',
    params
  })
}

// ==================== 采购日报 ====================

/**
 * 获取采购日报
 */
export function getPurchaseDailyReport(params) {
  return request({
    url: '/accountant/report/purchase/daily',
    method: 'get',
    params
  })
}

/**
 * 获取采购日报列表
 */
export function getPurchaseDailyReportList(params) {
  return request({
    url: '/accountant/report/purchase/daily/list',
    method: 'get',
    params
  })
}

// ==================== 企业年报 ====================

/**
 * 获取企业年报
 */
export function getCompanyAnnualReport(params) {
  return request({
    url: '/accountant/report/company/annual',
    method: 'get',
    params
  })
}

/**
 * 获取企业年报列表
 */
export function getCompanyAnnualReportList(params) {
  return request({
    url: '/accountant/report/company/annual/list',
    method: 'get',
    params
  })
}

